module.exports = __webpack_public_path__ + "img/self.a4efa25b.png";